export const STATUS_LABEL: Record<string, string> = {
  UNVERIFIED: "Unverified",
  VERIFIED: "Verified",
  MONITORING: "Monitoring",
  PAUSED: "Paused",
  NEW: "New",
  DETECTED: "Found",
  CONFIRMED: "Confirmed",
  DISMISSED: "Dismissed",
  ARCHIVED: "Archived",
  QUEUED: "Queued",
  CRAWLING: "Scanning",
  ANALYZING: "Comparing",
  COMPLETED: "Done",
  FAILED: "Failed",
  LOW: "Low match",
  POSSIBLE: "Possible match",
  HIGH: "High match",
  VERY_HIGH: "Very high match",
  MEDIUM: "Medium",
  CRITICAL: "Urgent",
  UNDER_REVIEW: "In review",
  FALSE_POSITIVE: "Not a copy",
  DRAFTING: "Drafting",
  READY: "Ready to send",
  SUBMITTED: "Submitted",
  ACKNOWLEDGED: "Acknowledged",
  ACTIONED: "Actioned",
  REJECTED: "Rejected",
  RESOLVED: "Resolved",
  CLOSED: "Closed",
  DRAFT: "Draft",
  INCOMPLETE: "Incomplete",
  APPROVED: "Approved",
  DUPLICATE: "Already filed",
  VALIDATING: "Checking",
  RETRY: "Retry",
  PENDING: "Pending",
  CREATED: "Created",
  EVIDENCE_ATTACHED: "Evidence attached",
  DRAFT_GENERATED: "Draft created",
  REVIEWED: "Reviewed",
  PROVIDER_RESPONSE: "Provider replied",
};

export const REPORT_TYPE_LABEL: Record<string, string> = {
  DMCA_COPYRIGHT_NOTICE: "Copyright notice",
  HOSTING_ABUSE: "Host report",
  CDN_ABUSE: "CDN report",
  REGISTRAR_ABUSE: "Domain registrar report",
  PLATFORM_COPYRIGHT: "Platform report",
  GOOGLE_LEGAL_REMOVAL: "Google removal request",
};

export function statusLabel(status?: string | null) {
  if (!status) return "—";
  return STATUS_LABEL[status] ?? status.replaceAll("_", " ");
}

export function reportTypeLabel(type?: string | null) {
  if (!type) return "—";
  return REPORT_TYPE_LABEL[type] ?? type.replaceAll("_", " ");
}

export function actionLabel(action: string) {
  return action;
}

export function noticeTitle(title: string) {
  return title;
}

export function noticeBody(body: string) {
  return body;
}

export const LEGAL_NOTICE =
  "A similarity score is not a legal finding. Confirm you own the original site and that the details are accurate before you send a report. Do not file a false claim.";

export function methodLabel(method?: string | null) {
  if (method === "HTML_META") return "Code on the site";
  return "Domain settings";
}
